const XLSX_MIME_TYPES = new Set([
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
]);

export const isXlsxFile = (file: File) => {
  const extension = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();

  return XLSX_MIME_TYPES.has(file.type) || extension === ".xlsx";
};
